import { BOOST_CATEGORY, BOOST_CODE } from '@packages/types';

import { Text } from '@elements/text';
import { useTripStore } from '@store';
import { sluggify, testProps } from '@utils';

export const DefaultBoostText = ({ boostCode }: { boostCode: BOOST_CODE }) => {
  const boostText = useTripStore(state => {
    const boost = state.trip.boosts.find(b => b.code === boostCode && b.isAdded);

    if (boost?.category === BOOST_CATEGORY.MY_STUFF) return boost?.name;
    const plural = boost?.duration && boost.duration > 1 ? 's' : '';
    return boost ? `${boost.name}: ${boost.duration} day${plural}` : null;
  });
  if (!boostText) return null;
  return <Text {...testProps(`policyDetails-boost-${sluggify(boostCode)}`)}>{boostText}</Text>;
};
